import AutoForm from './AutoForm'
export default AutoForm